import { render, staticRenderFns } from "./winList.vue?vue&type=template&id=37681b37&scoped=true"
import script from "./winList.vue?vue&type=script&lang=js"
export * from "./winList.vue?vue&type=script&lang=js"
import style0 from "./winList.vue?vue&type=style&index=0&id=37681b37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37681b37",
  null
  
)

export default component.exports